"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.languageOptions = void 0;
var languageOptionValues = [
    ['en_GB', 'en-gb', 'English (GB)', 'gb'],
    ['da_DK', 'da', 'Dansk', 'dk'],
    ['de_DE', 'de', 'Deutsch', 'de'],
    ['es_ES', 'es', 'Español', 'es'],
    ['fi_FI', 'fi', 'Suomi', 'fi'],
    ['fr_FR', 'fr', 'Français', 'fr'],
    ['it_IT', 'it', 'Italiano', 'it'],
    ['nb_NO', 'nb', 'Norsk (bokmål)', 'no', ['no', 'nn']],
    ['nl_NL', 'nl', 'Nederlands', 'nl'],
    ['pl_PL', 'pl', 'Polski', 'pl'],
    ['pt_BR', 'pt-br', 'Português do Brasil', 'br'],
    ['ru_RU', 'ru', 'Русский', 'ru', undefined, 'Russian'],
    ['sv_SE', 'sv', 'Svenska', 'se'],
    ['tr_TR', 'tr', 'Türkçe', 'tr'],
    ['zh_CN', 'zh-Hans', '中文 (简体)', 'cn', ['zh-cn', 'zh-hant'], 'Chinese'], // Adding Chinese (Simplified)
];
languageOptionValues.sort(function (a, b) {
    if ((a[5] || a[2]) < (b[5] || b[2])) {
        return -1;
    }
    if ((a[5] || a[2]) > (b[5] || b[2])) {
        return 1;
    }
    return 0;
});
exports.languageOptions = languageOptionValues.map(function (_a) {
    var id = _a[0], locale = _a[1], label = _a[2], flag = _a[3], alternativeLocales = _a[4];
    return ({
        id: id,
        locale: locale,
        label: label,
        flag: flag,
        alternativeLocales: alternativeLocales,
    });
});
